<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
         
        <!--
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15002842221.jpg"
                alt=""
                title="" /></a>
          </div>
          -->
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011452161.png"
                alt=""
                title=""/></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <a href="/" tabindex="101" class="breadCrumb_no" title="首頁">首頁</a>
        <router-link :to="{name:'公司簡介'}"><span>關於白金</span></router-link>
        <router-link :to="{name:'經營理念'}"><span>經營理念</span></router-link>
      </div>

      <h2 class="titleA">經營理念</h2>
      <div id="page_left">
        <div id="menu_out">
          <div id="menu_c">
            <ul class="m_top"></ul>
            <li>
              <router-link :to="{name:'公司簡介'}" class="menu_on0">關於白金</router-link>
              <span
                style="cursor: hand"
                class="arrow_class_close"
                onclick="allshow_show_menu2(this,'2279','http://www.ptotinc.com/','0','','2280')">
                <img
                  src="~@/assets/folder_close.png"
                  id="img_son_menu_2279"
                  class="class_sonimg_0"/>
              </span>
            </li>
            <div id="son_menu_2279" class="class_sondiv_0" style="display: ">
              <ol>
                <router-link :to="{name:'公司簡介'}" class="menu_on0">公司簡介</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'經營理念'}" class="menu_on2">經營理念</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'核心競爭力'}" class="menu_on0">核心競爭力</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業沿革'}" class="menu_on0">企業沿革</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業社會責任'}" class="menu_on0">企業社會責任</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'產業新聞'}" class="menu_on0">產業新聞</router-link>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div id="page_right_no">
        <!--###右側欄區塊###-->
      </div>

      <div id="page_main_2">
        <!--###內頁中間內容區塊###-->
        <div class="cC">
          <form
            method="POST"
            action="portal_c2_cnt.php?owner_num=c2_38424&amp;button_num=c2&amp;folder_id=2280&amp;search_type=1"
          >
            <div class="searchbar">
              <ul>
                <li>
                  尋找：

                  <select tabindex="62" name="search_field">
                    <option value="all_field">全部</option>
                    <option value="text_field_0">標題</option>
                  </select>
                  <input
                    tabindex="63"
                    name="search_word"
                    type="text"
                    class="input"
                    value=""
                  />
                  <input
                    tabindex="64"
                    name="search_b1"
                    type="submit"
                    class="btn"
                    value="查詢"
                  />
                  <!--<input name="Submit3" type="button" class="btn2" value="進階查詢" onclick="location.href='http://www.ptotinc.com/member/ptotinc/portal_c2_cnt.php?owner_num=c2_38424&button_num=c2&folder_id=2280&search_type=2';"/>-->
                </li>
              </ul>
            </div>
          </form>

          <div class="cate_info">     <span style="font-size: 15px;"><strong><span style="font-size: 18px;">經營理念</span></strong><br>
          <br>
          信念與承諾</span>
          <ul>
            <li><span style="font-size: 15px;">依客戶的需求，設計、開發各種光學產品之光學玻璃材料。</span></li>
            <li><span style="font-size: 15px;">與客戶共同研發、改進，提升客戶產品良率。</span></li>
            <li><span style="font-size: 15px;">提供各階段半成品及成品，以滿足客戶製程及成本需要。</span></li>
            <li><span style="font-size: 15px;">主動開發新的光學玻璃材料及應用，引領市場對光學玻璃的需求。</span></li>
          </ul>
          </div>

          <ul id="c_list"></ul>

          <br /><br />
          <p style="text-align: center"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'concept',
  // mixins: [sliderPro],
  data () {
    return {
      msg: 'Concept'
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    // sliderPro.m1()
    // sliderProAddTitle('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
    // sliderPro.initialSliderPro()
    // sliderPro.m1('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/about/Concept.vue